var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpcIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12H0.5C0.225 12 0 11.775 0 11.5V0.5C0 0.225 0.225 0 0.5 0H11.5C11.775 0 12 0.225 12 0.5V11.5C12 11.775 11.775 12 11.5 12ZM1 11H11V1H1V11Z",
    fill: "#3C7AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8H4.5C4.225 8 4 7.775 4 7.5V4.5C4 4.225 4.225 4 4.5 4H7.5C7.775 4 8 4.225 8 4.5V7.5C8 7.775 7.775 8 7.5 8ZM5 7H7V5H5V7Z",
    fill: "#3C7AF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10H2.5C2.225 10 2 9.775 2 9.5V2.5C2 2.225 2.225 2 2.5 2H9.5C9.775 2 10 2.225 10 2.5V5.5C10 5.775 9.775 6 9.5 6H7.5C7.225 6 7 5.775 7 5.5C7 5.225 7.225 5 7.5 5H9V3H3V9H8.295L9.15 8.145C9.345 7.95 9.66 7.95 9.855 8.145C10.05 8.34 10.05 8.655 9.855 8.85L8.855 9.85C8.76 9.945 8.635 9.995 8.5 9.995V10Z",
    fill: "#3C7AF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpcIcon);
export default __webpack_public_path__ + "static/media/epc-icon.f7356fe834275a63a9fcc3bea7c683f8.svg";
export { ForwardRef as ReactComponent };